import { createSlice } from '@reduxjs/toolkit';

import { TUser } from 'shared/types/user';

const initialState: TUser = {
  isAuthenticated: false,
  anonymousUserId: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  selectors: {
    selectUser: state => state,
    selectIsAuthenticated: state => state.isAuthenticated,
  },
});

export const {
  reducer: userReducer,
  // eslint-disable-next-line no-empty-pattern
  actions: {},
  selectors: { selectUser, selectIsAuthenticated },
} = userSlice;
